export enum RoutesEnum {
  ACTIONS = '/actions',
  AUDIT_LOG = '/reports/audit-log',
  EQUIPMENT = '/equipment',
  EQUIPMENT_GROUPS = '/equipment/groups',
  HOME = '/',
  LICENSES = '/licenses',
  LOGIN = '/login',
  LOGOUT = '/logout',
  MFA = '/mfa',
  MOBILE_AUTH = '/mobile-auth',
  PEOPLE = '/people',
  PEOPLE_GROUPS = '/people/groups',
  RELEASES = '/releases',
  REPORTS = '/reports',
  REPORTS_SITE_PRESENCE = '/reports/site-presence',
  REPORTS_TIME_IN_ZONE = '/reports/time-in-zone',
  REPORTS_TRIPS = '/reports/trips',
  REPORTS_UTILIZATION = '/reports/utilization',
  REPORTS_ZONE_ENTRY_EXIT = '/reports/zone-entry-exit',
  RESERVATIONS = '/reservations',
  RESERVATIONS_HISTORY = '/reservations/history',
  RESTORE_PASSWORD = '/restore-password',
  SETTINGS = '/settings',
  SITE_SELECT = '/site-select',
  TAG_DIAGNOSTICS = '/reports/tag-diagnostics',
  TERMS = '/terms',
  TERMS_OF_USE = '/terms-of-use',
  SITE_MANAGEMENT = '/settings/site-management'
}

export enum NotifyEnum {
  ERROR = 'error',
  INFO = 'info',
  SUCCESS = 'success',
}

export enum RolesEnum {
  ENGINEER = 'engineer',
  KOTO = 'koto',
  MANAGER = 'manager',
  SUBCONTRACTOR = 'subcontractor',
  WORKER = 'worker',
}

export enum StatusEnum {
  ERROR = 'error',
  IDLE = 'idle',
  LOADING = 'loading',
  SUCCESS = 'success',
}

export enum ZPSStatusEnum {
  ACTIVE = 'active',
  EXPIRED = 'expired',
  INACTIVE = 'inactive',
  PENDING = 'pending',
}

export enum ReservationStatusEnum {
  ACTIVE = 'active',
  APPROVED = 'approved',
  COMPLETED = 'completed',
  INACTIVE = 'inactive',
  REJECTED = 'rejected',
  REQUESTED = 'requested',
}

export enum AvailabilityEnum {
  AVAILABLE = 'Available',
  RESERVED = 'Reserved',
}

export enum TagsAttachedEnum {
  NO = 'no',
  YES = 'yes',
}

export enum PopupTypeEnum {
  ALERTS = 'alerts',
  CONFIRM_DELETE = 'confirm_delete',
  CONFIRM_DELETE_FIRM = 'confirm_delete_firm',
  CONFIRM_DELETE_WORKER = 'confirm_delete_worker',
  CONFIRM_SAVE = 'confirm_save',
  CONFIRM_SAVE_SITE_HOURS = 'confirm_save_site_hours',
  DEFAULT = 'default',
  EQUIPMENT = 'equipment',
  EQUIPMENT_COMBINED = 'equipment_combined',
  EQUIPMENT_CREATE = 'equipment_create',
  EQUIPMENT_DELETE = 'equipment_delete',
  EQUIPMENT_EDIT = 'equipment_edit',
  EQUIPMENT_RESERVE = 'equipment_reserve',
  EQUIPMENT_TYPES_AND_SUBTYPES = 'equipment_types_and_subtypes',
  GROUPS_CREATE = 'groups_create',
  GROUPS_DELETE = 'groups_delete',
  GROUPS_EDIT = 'groups_edit',
  MAP = 'map',
  MAP_FILTER = 'map_filter',
  PEOPLES = 'subcontractors',
  REPORTS = 'reports',
  REQUESTS = 'requests',
  RESERVATIONS = 'reservations',
  RESERVATIONS_CONFIRM_APPROVE = 'reservations_confirm_approve',
  RESERVATIONS_CONFIRM_DELETE = 'reservations_confirm_delete',
  RESERVATIONS_CONFIRM_REJECT = 'reservations_confirm_reject',
  RESERVATIONS_CONFIRM_SUBMIT = 'reservations_confirm_submit',
  SETTINGS = 'settings',
  SINGLE_ASSET_MAP_VISUALIZATION = 'single_asset_map_visualization',
  SITE_MANAGEMENT_SITE_EDIT = 'site_management_site_edit',
  SUBCONTRACTORS_FIRM_EDIT = 'subcontractors_firm_edit',
  SUBCONTRACTORS_INVITE = 'subcontractors_invite',
  SUBCONTRACTORS_WORKER_EDIT = 'subcontractors_worker_edit',
  TERMS_OF_USE = 'terms_of_use',
  ZONE = 'zone',
  ZPS_ACCESS_EDIT = 'zps_access_edit',
  ZPS_RESEND_VERIFICATION_EMAIL = 'zps_resend_verification_email',
}

export enum SidebarViewEnum {
  ADD_ZONE = 'add_zone',
  EDIT = 'edit',
  EDIT_ZONE = 'edit_zone',
  VIEW = 'view',
}
